var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"mx-4"},[_c('p',{staticClass:"text-h6"},[_vm._v(_vm._s(_vm.$route.query.name))]),_c('section',{staticStyle:{"height":"750px"},attrs:{"id":"containerx"}})])}
var staticRenderFns = []

export { render, staticRenderFns }